var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoginFail)?_c('el-button',{on:{"click":_vm.loginAgain}},[_vm._v("重新登录")]):_c('div',[_vm._v("登录中，请稍后...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }